import type {
  Screen,
  ScreenContext,
  ScreenName,
  ScreenParams,
} from './presentation/screens/types';

export type ScreenRegistry = Record<ScreenName, () => Screen>;

export interface Router {
  start(initial: ScreenName, params?: ScreenParams): void;
}

export function createRouter(root: HTMLElement, registry: ScreenRegistry): Router {
  let current: Screen | null = null;

  function goto(screenName: ScreenName, params: ScreenParams = {}): void {
    const factory = registry[screenName];
    if (!factory) {
      throw new Error(`Unknown screen: ${screenName}`);
    }
    if (current) {
      current.unmount();
    }
    root.replaceChildren();
    current = factory();
    const ctx: ScreenContext = { goto, params };
    current.mount(root, ctx);
  }

  return {
    start(initial, params) {
      goto(initial, params);
    },
  };
}
